import { React, useEffect } from "react";
import { Container } from "@prestosports/commons-ui";
import Box from "@material-ui/core/Box";
import Match from "../components/Match";
import EmptyMatch from "../components/EmptyMatch";
import { useMatchesContext } from "../../../state/matches/context";
import matchContainerStyles from "../styles/MatchContainer.styles";

const SinglesContainer = ({ event = {} }) => {
	const classes = matchContainerStyles();

	const { state, getMatches } = useMatchesContext();
	const singles = state.singles();

	useEffect(() => {
		if (event) {
			getMatches(event.id);
		}
	}, [event]);

	return (
		<Container fullHeight noPaper>
			<Box className={classes.matchContainer}>
				<EmptyMatch isSingle />
				{singles
					? singles.map((match) => <Match match={match} key={match.name} />)
					: null}
			</Box>
		</Container>
	);
};

export default SinglesContainer;
